// theme/theme.js or wherever you decide to place it

export const COLORS = {
  // Primary Palette
  primary: '#0A7AFF',
  primaryLight: '#E6F2FF',

  // Neutrals
  white: '#FFFFFF',
  black: '#000000',
  lightGray: '#F5F5F7',
  gray: '#A0A4A8',
  darkGray: '#333333',

  // Semantic Colors
  success: '#34C759',
  warning: '#FF9500',
  danger: '#FF3B30',
};

export const SIZES = {
  base: 8,
  font: 14,
  radius: 12,
  padding: 24,
  h1: 30,
  h2: 22,
  h3: 16,
  body1: 30,
  body2: 22,
  body3: 16,
  body4: 14,
};

export const FONTS = {
  h1: { fontFamily: 'System', fontSize: SIZES.h1, lineHeight: 36 },
  h2: { fontFamily: 'System', fontSize: SIZES.h2, lineHeight: 30 },
  h3: { fontFamily: 'System', fontSize: SIZES.h3, lineHeight: 22 },
  body1: { fontFamily: 'System', fontSize: SIZES.body1, lineHeight: 36 },
  body2: { fontFamily: 'System', fontSize: SIZES.body2, lineHeight: 30 },
  body3: { fontFamily: 'System', fontSize: SIZES.body3, lineHeight: 22 },
  body4: { fontFamily: 'System', fontSize: SIZES.body4, lineHeight: 22 },
};

const appTheme = { COLORS, SIZES, FONTS };
export default appTheme;
